import styles from './index.module.less'
import Title from '@/components/BlockTitleTwo'
import icon from '@/assets/image/gea/addressPublicity.svg'
import SearchInput from '@/components/SearchInputTwo'
import BlockTitle from '@/components/BockTitle'
import CardInfo from './components/cardInfo'
import SlideBtn, { type IbtnListItem } from '@/components/SlideBtn/index'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  getRegionAccountList,
  getRestAccountGovernanceAddress,
  getRestAccountSystemAddress,
} from '@/api/addressFormula'
import { useRequest } from 'ahooks'
import {
  GovernanceCommunityAccount,
  GovernanceCommunityAccountData,
  GovernanceCommunityData,
  GovernanceData,
  RegionAccount,
} from '@/api/addressFormula/interface'
import RegionList from './components/regionList'
import GovList from './components/govList'
const AddressPublicity = () => {
  const { t } = useTranslation()
  const [btnListOne, setBtnListOne] = useState<IbtnListItem[]>([
    {
      name: t('explorer_218'), // 全球区地址
      value: '0',
      active: true,
    },
    {
      name: t('explorer_219'), // 中国区地址
      value: '1',
      active: false,
    },
    {
      name: t('explorer_220'), // 全网置换地址
      value: '2',
      active: false,
    },
  ])

  const [pageParams, setPageParams] = useState<{
    offset: number
    limit: number
  }>({
    offset: 0,
    limit: 10,
  })

  // 全网治理地址
  const [govData, setGovData] = useState<GovernanceCommunityAccountData>()
  // IBC跨链映射地址
  const [transferData, setTransferData] = useState<GovernanceCommunityAccountData>()
  // 全网金库地址
  const [mintData, setMintData] = useState<GovernanceCommunityAccountData>()
  // 全网区块奖励备用地址
  const [mintRewardData, setMintRewardData] = useState<GovernanceCommunityAccountData>()
  // 全网GasFee地址
  const [globalFeeAccount, setGlobalFeeAccount] = useState<GovernanceCommunityAccountData>()

  const [globalList, setGlobalList] = useState<RegionAccount>({} as RegionAccount)
  const [chnList, setChnList] = useState<RegionAccount>({} as RegionAccount)

  // 系统地址
  const { loading } = useRequest(() => getRestAccountSystemAddress(pageParams), {
    refreshDeps: [pageParams],
    onSuccess: (res: GovernanceData) => {
      if (res.governance_community_accounts_aggregate) {
        const gov = res.governance_community_accounts.find((item) => item.name === 'gov')
        if (gov) {
          setGovData(gov)
        }
        const transfer = res.governance_community_accounts.find((item) => item.name === 'transfer')
        if (transfer) {
          setTransferData(transfer)
        }
        const mint = res.governance_community_accounts.find((item) => item.name === 'mint')
        if (mint) {
          setMintData(mint)
        }
        const mintReward = res.governance_community_accounts.find(
          (item) => item.name === 'mint_reward_pool',
        )
        if (mintReward) {
          setMintRewardData(mintReward)
        }
        const globalFee = res.governance_community_accounts.find(
          (item) => item.name === 'global_fee_account',
        )
        if (globalFee) {
          setGlobalFeeAccount(globalFee)
        }
      }
    },
  })

  // 区地址
  const getRegionAccountListFn = async () => {
    const res = await getRegionAccountList()
    if (res?.region_account_list?.length) {
      const globalListData = res.region_account_list.find(
        (item) => item.region_id === 'global_village',
      )
      const chnListData = res.region_account_list.find((item) => item.region_id === 'chn')
      if (globalListData) {
        setGlobalList(globalListData)
      }
      if (chnListData) {
        setChnList(chnListData)
      }
    }
  }

  useEffect(() => {
    getRegionAccountListFn()
  }, [])

  const listData = useMemo(() => {
    if (btnListOne[0].active) {
      return {
        data: globalList,
        showRegion: true,
        showGov: false,
      }
    } else if (btnListOne[1].active) {
      return {
        data: chnList,
        showRegion: true,
        showGov: false,
      }
    } else {
      return {
        data: null,
        showRegion: false,
        showGov: true,
      }
    }
  }, [btnListOne, globalList, chnList])

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        {/* 地址公示 */}
        <Title title={t('explorer_32')} icon={icon} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      <div className={styles.paginationWrap}>
        {/* 系统地址 */}
        <BlockTitle title={t('explorer_192')}></BlockTitle>
      </div>
      {/* 系统地址--列表 */}
      <div className={styles.cardWrap}>
        {/* 全网治理地址 */}
        <CardInfo
          data={govData as GovernanceCommunityAccountData}
          description={t('explorer_228')}
          title={t('explorer_193')}
        ></CardInfo>

        {/* IBC跨链映射地址 */}
        {/*<CardInfo
          data={transferData as GovernanceCommunityAccountData}
          title={t('explorer_194')}
          description={t('explorer_229')}
        ></CardInfo>*/}

        {/* 全网金库地址 */}
        {/*<CardInfo
          data={mintData as GovernanceCommunityAccountData}
          title={t('explorer_195')}
          description={t('explorer_230')}
        ></CardInfo>*/}

        {/* 全网区块奖励备用地址 */}
        <CardInfo
          data={mintRewardData as GovernanceCommunityAccountData}
          title={t('explorer_196')}
          description={t('explorer_231')}
        ></CardInfo>
        {/* 全网GasFee地址 */}
        <CardInfo
          data={globalFeeAccount as GovernanceCommunityAccountData}
          title={t('explorer_315')}
          description={t('explorer_316')}
          // showTooltip={true}
          // tipDescription={t('explorer_317')}
        ></CardInfo>
      </div>

      {/* 全球区地址、中区地址、全网置换地址 */}
      <div className={styles.slide_btn_wrap}>
        <SlideBtn btnList={btnListOne} setBtnList={setBtnListOne}></SlideBtn>
      </div>

      <div style={{ display: listData.showRegion ? 'block' : 'none' }} className={styles.cardWrap}>
        {<RegionList listData={listData.data as RegionAccount}></RegionList>}
      </div>
      <div style={{ display: listData.showGov ? 'block' : 'none' }} className={styles.cardWrap}>
        {<GovList></GovList>}
      </div>
    </div>
  )
}

export default AddressPublicity
